import { useState } from "react";
import { Button, Form, Input } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

const MAX_ACTIVITIES = 5;

// Renders Form.Items for act1/week1_hours .. act5/week5_hours directly
// (fixed named fields, not a single array-valued field) so the submitted
// payload and DB columns stay exactly as they were — this only changes how
// many rows are shown at once. Activity 1 is always visible; "Add Activity"
// reveals the next row up to 5, and only the last row can be removed (undo
// last add), which avoids having to shift data between numbered fields.
const ActivityHoursListField = ({ form }) => {
  const watchedTrailing =
    Form.useWatch(
      (values) =>
        [2, 3, 4, 5].map((n) => values?.[`act${n}`] || values?.[`week${n}_hours`]),
      form
    ) || [];

  const highestFilled = watchedTrailing.reduce(
    (max, val, i) => (val ? Math.max(max, i + 2) : max),
    1
  );

  const [addedCount, setAddedCount] = useState(1);
  const visibleCount = Math.max(addedCount, highestFilled);

  const handleAdd = () => setAddedCount((c) => Math.min(c + 1, MAX_ACTIVITIES));

  const handleRemove = (n) => {
    form.setFieldsValue({ [`act${n}`]: undefined, [`week${n}_hours`]: undefined });
    setAddedCount((c) => Math.max(1, c - 1));
  };

  return (
    <>
      {Array.from({ length: visibleCount }, (_, i) => i + 1).map((n) => (
        <div key={n} style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
          <div style={{ flex: 1 }}>
            <Form.Item name={`act${n}`} label={`Activity ${n}`}>
              <Input placeholder={`Enter Activity ${n}`} />
            </Form.Item>
            <Form.Item name={`week${n}_hours`} label={`No. of hours per week ${n}`}>
              <Input />
            </Form.Item>
          </div>
          {n === visibleCount && visibleCount > 1 && (
            <Button
              danger
              type="text"
              icon={<DeleteOutlined />}
              onClick={() => handleRemove(n)}
              style={{ marginTop: 4 }}
            />
          )}
        </div>
      ))}

      {visibleCount < MAX_ACTIVITIES && (
        <Button
          type="dashed"
          icon={<PlusOutlined />}
          onClick={handleAdd}
          style={{ width: "100%", marginBottom: 16 }}
        >
          Add Activity
        </Button>
      )}
    </>
  );
};

export default ActivityHoursListField;
